import {Stack, Typography} from '@mui/material';
import React from 'react';
import {StyledContainer, StyledIcon} from './styles';
import {DataContentCardType} from './types';

export const DataContentCard = ({iconName, title, description, iconSize}: DataContentCardType) => {
	if (!description) return null;

	return (
		<StyledContainer>
			<StyledIcon size={iconSize} name={iconName} />
			<Stack>
				<Typography variant="body2" color={'text.secondary'}>
					{title}
				</Typography>
				<Typography variant="body1">{description}</Typography>
			</Stack>
		</StyledContainer>
	);
};
